// Deterministic avatar colours + initials, matching Element's approach of
// hashing an id to a fixed palette so a given user/room always looks the same.

const PALETTE = [
  "#368bd6", // blue
  "#ac3ba8", // purple
  "#03b381", // green
  "#e64f7a", // pink
  "#ff812d", // orange
  "#2dc2c5", // teal
  "#5c56f5", // indigo
  "#74d12c", // lime
];

function hash(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function colorForId(id: string): string {
  return PALETTE[hash(id) % PALETTE.length];
}

export function initialFor(name: string): string {
  const trimmed = (name || "").trim().replace(/^[@#!]/, "");
  if (!trimmed) return "?";
  // Grab first codepoint (handles emoji / non-latin reasonably).
  const first = Array.from(trimmed)[0];
  return first.toUpperCase();
}
